import { Injectable } from '@angular/core';
import { InMemoryCacheService } from 'src/app/common';


@Injectable()
export class SeoLimitsResolver  {
  public constructor(private cache: InMemoryCacheService) {}

  public async resolve(): Promise<string> {
    if (this.cache?.seoLimits) {
      return '';
    }

    this.cache.loading = true;
    try {
      await this.cache.getSeoLimits();
    } finally {
      this.cache.loading = false;
    }

    return '';
  }
}
